<template>
  <Teleport v-if="breadcrumbTarget != null" :to="breadcrumbTarget">
    <span class="mobile-header-title" :title="title">{{ title }}</span>
  </Teleport>
</template>

<script setup lang="ts">
import { onMounted, shallowRef } from "vue";

defineProps<{
  title: string;
}>();

const breadcrumbTarget = shallowRef<HTMLElement>();

onMounted(() => {
  breadcrumbTarget.value = document.getElementById("breadcrumbs") ?? undefined;
});
</script>
